import { useState } from "react";
import { homeService } from "@miplatform/api";
import { AutocompleteOption } from "@miplatform/components";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IHomeListResponse } from "@miplatform/types";
import { buildSearchQuery, createUUID, flattenHome } from "@miplatform/utils";
import { FilterObject } from "../types";

type HomeListAutocompleteOption = AutocompleteOption & IHomeListResponse;

const GET_HOMES_UUID = createUUID();

export const useHomeSearchAutocomplete = ({ search }: { search: string }) => {
  const stateManager = useComponentState();
  const [homeOptions, setHomeOptions] =
    useState<HomeListAutocompleteOption[]>();

  const getHomeOptions = (): Promise<void> => {
    const searchQuery = buildSearchQuery(search, ["address/addressLine1"]);
    const filterObj: FilterObject = { ...searchQuery };

    stateManager.abort(GET_HOMES_UUID);

    return stateManager.run(async () => {
      const res = await homeService.homes.getAll({
        filters: filterObj,
        sort: "address/addressLine1 asc",
        top: 10,
      });

      if (res.status !== HTTP_STATUSES.OK) {
        return;
      }

      const flattenedData = res.data.map(flattenHome);
      setHomeOptions(flattenedData);
    }, GET_HOMES_UUID);
  };

  return {
    getHomeOptions,
    homeOptions,
    loading: stateManager.isBusy(),
  };
};
